import React,{useEffect, useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import {
  sidebarAction
} from "../../redux/reducer/SidebarSlice";
import {GetProfileRequest} from '../../redux/reducer/FetchDataReducer'

const NavMenu = () => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const sidebarShow = useSelector((state) => state.sidebarReducer.isSidebarshow)
  const fetchReducer = useSelector((state) => state.FetchDataReducer?.profileResponse)
  const [show, setShow] = useState(false);
  useEffect(()=>{
    dispatch(GetProfileRequest())
  },[])

  
 var DynmicClass = ""

if(sidebarShow === true)
{
  DynmicClass = ""
}
if(sidebarShow === false)
{
  DynmicClass = "closes"
}

var width = window.innerWidth < 768;
const handleClose = () => setShow(false);

const LogoutHandle = ()=>{
  setShow(false)
  dispatch(sidebarAction(sidebarShow)) 
  localStorage.clear();
  navigate("/login")
}




  return (
    <div className={`left-panel sidebar-fixed ${DynmicClass}`}>
      <div className="panel-logo">
          <div className='profile-pic'>
            <img src={fetchReducer?.data?.profile_picture} alt="profile" id="editImg" />
          
          </div>
          <h5>{fetchReducer?.data?.full_name}</h5>
        <button
        className="close-btn"
        onClick={() =>
          dispatch(sidebarAction(true)) 
        }
            >
        <i className="fa-solid fa-xmark"></i>
            </button>
      </div>
  
      <div className="sidebar">
   
        <ul>
          <li>
          
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : undefined)}
              onClick={() =>
                width ? dispatch(sidebarAction(true)) : null
                }
            >
              <span>
              <i className="fa-solid fa-gauge"></i>
              </span>
              Dashboard
            </NavLink>
          </li>
          <li>
          
          <NavLink
            to="/earning"
            className={({ isActive }) => (isActive ? "active" : undefined)}
            onClick={() =>
              width ? dispatch(sidebarAction(true)) : null
              }
          >
            <span>
            <i className="fa-solid fa-dollar-sign"></i>
            </span>
            Earnings
          </NavLink>
        </li>
        <li>
          
            <NavLink
              to="/delevery-history"
              className={({ isActive }) => (isActive ? "active" : undefined)}
              onClick={() =>
                width ? dispatch(sidebarAction(sidebarShow)) : null
                }
            >
              <span>
              <i className="fa-solid fa-clock"></i>
              </span>
              Delivery History
            </NavLink>
          </li>
          <li>
          
            <NavLink
              to="/profile"
              className={({ isActive }) => (isActive ? "active" : undefined)}
              onClick={() =>
                width ? dispatch(sidebarAction(true)) : null
                }
            >
              <span>
              <i className="fa-solid fa-user"></i>
              </span>
              My Profile
            </NavLink>
          </li>
          <li>
          
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : undefined)}
              onClick={() =>
                width ? dispatch(sidebarAction(true)) : null
                }
            >
              <span>
              <i className="fa-solid fa-bell"></i>
              </span>
              Notification
            </NavLink>
          </li>
          <li>
          
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : undefined)}
              onClick={() =>
                width ? dispatch(sidebarAction(true)) : null
                }
            >
              <span>
              <i className="fa-solid fa-headset"></i>
              </span>
              Support
            </NavLink>
          </li>
          <li>
          <span>
          <i className="fa-solid fa-right-from-bracket"></i>
              </span>
            <button onClick={()=>setShow(true)}>Logout</button>
           
          </li>
        </ul>
       
      </div>
 <Modal show={show} onHide={handleClose} centered size="sm" className='AlertMsg'>
    <Modal.Header>
      <Modal.Title><i class="fa-solid fa-triangle-exclamation"></i> Alert !</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h4>Are You sure log out ?</h4>
      <ul>
      <li>
        <button onClick={handleClose} className='btn btn-md btn-danger'>
            No
        </button>
     
      </li>
      <li>
      <button onClick={LogoutHandle} className='btn btn-md btn-success'>
            Yes
        </button>
    
      </li>
    </ul>

    </Modal.Body>
  
   
  </Modal>
    </div>
  )
}

export default NavMenu